export default __webpack_public_path__ + "static/media/term-con.7160479f.pdf";